import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'providers/AuthProvider';

interface RequireAuthProps {
  children: ReactNode;
}

const RequireAuth = ({ children }: RequireAuthProps) => {
  const { isAuthenticated, isLoggingOut } = useAuth();

  // Skip redirect during logout process to prevent blinking
  if (isLoggingOut) {
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
